import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { FlexRow } from 'components/atoms/Flex';
import StarRating from '../../review/StarRating/StarRating';
import { Badge } from 'components/molecules/Badge';
import { Image } from 'components/core/Image';
import ssIcon from 'assets/images/logos/ss-icon.svg';
import googleIcon from 'assets/images/logos/google-icon.png';

import './ReviewBar.scss';

export function ReviewBar(props) {
	const badgeIconSrc =
		props.icon === 'google' || props.icon === googleIcon
			? googleIcon
			: ssIcon;
	const badgeIconAlt =
		badgeIconSrc === googleIcon ? 'Google Icon' : 'SS Icon';

	return (
		<Badge
			badgeIcon={
				<Image
					src={badgeIconSrc}
					alt={badgeIconAlt}
				/>
			}
			badgeText={
				<FlexRow>
					<StarRating
						width={9}
						height={9}
						rating={props.average}
						fillColor="#146FB4"
						outOf={5}
					/>

					<Text
						className="average"
						color="priceBlue"
						weight="extraBold"
						last
					>
						{props.average.toFixed(1)}
					</Text>

					<Text
						className="number"
						color="blue"
						last
					>
						({props.number})
					</Text>
				</FlexRow>
			}
			badgeColor="blue"
		></Badge>
	);
}

ReviewBar.propTypes = {
	average: PropTypes.number,
	number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
